var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbLogoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 143.57,
    height: 112.921,
    viewBox: "0 0 143.57 112.921",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -6.609,
    y1: 0.5,
    x2: -5.385,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a3a3a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -6.907,
    y1: 0.5,
    x2: -5.541,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -7.163,
    y1: 0.5,
    x2: -5.748,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.076,
    y1: -0.07,
    x2: 0.957,
    y2: 1.074,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    transform: "translate(-588.5 -119.723)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_124",
    "data-name": "Group 124",
    transform: "translate(593.947 127.919)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_124",
    "data-name": "Rectangle 124",
    width: 83.24,
    height: 83.24,
    rx: 5,
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 81.685, 103.229)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_124_-_Outline",
    "data-name": "Rectangle 124 - Outline",
    d: "M6.278,0H79.054a6.285,6.285,0,0,1,6.278,6.278V79.054a6.285,6.285,0,0,1-6.278,6.278H6.278A6.285,6.285,0,0,1,0,79.054V6.278A6.285,6.285,0,0,1,6.278,0ZM79.054,83.24a4.19,4.19,0,0,0,4.185-4.185V6.278a4.19,4.19,0,0,0-4.185-4.185H6.278A4.19,4.19,0,0,0,2.093,6.278V79.054A4.19,4.19,0,0,0,6.278,83.24Z",
    transform: "matrix(-0.966, -0.259, 0.259, -0.966, 82.425, 104.511)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125",
    transform: "translate(604.515 119.829)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_125",
    "data-name": "Rectangle 125",
    width: 80.434,
    height: 80.434,
    rx: 5,
    transform: "translate(71.087 111.304) rotate(-150)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_125_-_Outline",
    "data-name": "Rectangle 125 - Outline",
    d: "M6.278,0H76.249a6.285,6.285,0,0,1,6.278,6.278V76.249a6.285,6.285,0,0,1-6.278,6.278H6.278A6.285,6.285,0,0,1,0,76.249V6.278A6.285,6.285,0,0,1,6.278,0ZM76.249,80.434a4.19,4.19,0,0,0,4.185-4.185V6.278a4.19,4.19,0,0,0-4.185-4.185H6.278A4.19,4.19,0,0,0,2.093,6.278V76.249a4.19,4.19,0,0,0,4.185,4.185Z",
    transform: "translate(71.47 112.733) rotate(-150)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126",
    transform: "translate(619.148 119.723)",
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_126",
    "data-name": "Rectangle 126",
    width: 77.754,
    height: 77.754,
    rx: 5,
    transform: "translate(56.461 111.441) rotate(-135)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_126_-_Outline",
    "data-name": "Rectangle 126 - Outline",
    d: "M6.278,0H73.569a6.285,6.285,0,0,1,6.278,6.278V73.569a6.285,6.285,0,0,1-6.278,6.278H6.278A6.285,6.285,0,0,1,0,73.569V6.278A6.285,6.285,0,0,1,6.278,0ZM73.569,77.754a4.19,4.19,0,0,0,4.185-4.185V6.278a4.19,4.19,0,0,0-4.185-4.185H6.278A4.19,4.19,0,0,0,2.093,6.278V73.569a4.19,4.19,0,0,0,4.185,4.185Z",
    transform: "translate(56.461 112.921) rotate(-135)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_127",
    "data-name": "Rectangle 127",
    width: 86.045,
    height: 86.045,
    rx: 5,
    transform: "translate(675.591 231.155) rotate(180)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_127_-_Outline",
    "data-name": "Rectangle 127 - Outline",
    d: "M6.278,0H81.86a6.285,6.285,0,0,1,6.278,6.278V81.86a6.285,6.285,0,0,1-6.278,6.278H6.278A6.285,6.285,0,0,1,0,81.86V6.278A6.285,6.285,0,0,1,6.278,0ZM81.86,86.045a4.19,4.19,0,0,0,4.185-4.185V6.278A4.19,4.19,0,0,0,81.86,2.093H6.278A4.19,4.19,0,0,0,2.093,6.278V81.86a4.19,4.19,0,0,0,4.185,4.185Z",
    transform: "translate(676.638 232.201) rotate(180)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M9.867,35.622l2.3,3.564c.1.177.126.4-.152.4H10.069a.424.424,0,0,1-.455-.228L7.541,35.951h-2v3.412s-.1.228-.227.228H3.573a.233.233,0,0,1-.253-.228V29.278s.1-.227.253-.227H8.1a4.359,4.359,0,0,1,2.654.708,3.278,3.278,0,0,1,1.213,2.7,3.243,3.243,0,0,1-1.188,2.578,4.092,4.092,0,0,1-.935.581Zm-4.3-4.676v3.109H7.744A2.636,2.636,0,0,0,9.109,33.8a1.647,1.647,0,0,0,.051-2.553,2.118,2.118,0,0,0-1.213-.3H5.595Z",
    transform: "translate(594.619 165.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M12.892,39.834a5.427,5.427,0,1,1,0-10.844,5.426,5.426,0,1,1,0,10.844Zm0-8.746a3.337,3.337,0,0,0,0,6.673,3.338,3.338,0,0,0,0-6.673Z",
    transform: "translate(600.592 165.437)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M14.372,29.065a.212.212,0,0,1,.227.227v8.342h4.5a.233.233,0,0,1,.253.227v1.491s-.1.227-.253.227H12.6a.233.233,0,0,1-.253-.227V29.267s.1-.227.253-.227h1.744Z",
    transform: "translate(608.414 165.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M17.692,29.065a.212.212,0,0,1,.228.227v8.342h4.5a.233.233,0,0,1,.253.227v1.491s-.1.227-.253.227h-6.5a.233.233,0,0,1-.253-.227V29.267s.1-.227.253-.227h1.744Z",
    transform: "translate(613.486 165.513)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M21,29.05a.212.212,0,0,1,.227.227V39.363s-.1.228-.227.228H19.253A.233.233,0,0,1,19,39.363V29.278s.1-.227.253-.227Z",
    transform: "translate(618.574 165.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M27.99,29.277s.1-.227.228-.227h1.668s.228.1.228.227V39.363s-.1.228-.228.228H28.344a.425.425,0,0,1-.43-.228l-5.056-6.6v6.6s-.1.228-.227.228H20.963a.233.233,0,0,1-.253-.228V29.278s.1-.227.253-.227H22.5c.177,0,.278.051.43.253l5.056,6.6V29.278Z",
    transform: "translate(621.187 165.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M33.937,29.692c.152.1.177.2.1.329l-.708,1.491c-.051.126-.177.126-.3.1a5.249,5.249,0,0,0-2.326-.607,3.319,3.319,0,0,0-3.286,3.387A3.235,3.235,0,0,0,30.7,37.857a4.227,4.227,0,0,0,2.25-.607V35.961H30.8s-.227-.1-.227-.228V34.217s.1-.227.227-.227h4.019a.212.212,0,0,1,.227.227V39.45s-.1.228-.227.228H33.179s-.228-.1-.228-.228v-.177a5.267,5.267,0,0,1-2.477.581,5.079,5.079,0,0,1-5.384-5.435,5.49,5.49,0,0,1,5.662-5.409,6.556,6.556,0,0,1,3.185.733Z",
    transform: "translate(627.878 165.467)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M7.7,46.551H3.583a.233.233,0,0,1-.253-.227V36.238s.1-.228.253-.228H6.768a4.291,4.291,0,0,1,2.578.657,2.42,2.42,0,0,1,1.011,2.022,2.283,2.283,0,0,1-1.314,2.25v.051a2.554,2.554,0,0,1,2.174,2.7c0,1.972-1.769,2.856-3.539,2.856Zm-.076-8.493a1.513,1.513,0,0,0-.885-.253H5.554v2.477H6.616a1.975,1.975,0,0,0,.91-.152,1.116,1.116,0,0,0,.581-1.062,1.13,1.13,0,0,0-.48-1.011Zm.581,4.221A3.034,3.034,0,0,0,6.894,42.1H5.554v2.654H7.223a2.452,2.452,0,0,0,.986-.152,1.159,1.159,0,0,0,.733-1.188A1.191,1.191,0,0,0,8.209,42.279Z",
    transform: "translate(594.634 176.162)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M9.132,36.025a.212.212,0,0,1,.227.227v8.342h4.5a.233.233,0,0,1,.253.228v1.491s-.1.228-.253.228h-6.5a.233.233,0,0,1-.253-.228V36.227s.1-.227.253-.227H9.107Z",
    transform: "translate(600.409 176.146)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M15.642,46.794a5.427,5.427,0,1,1,0-10.844,5.426,5.426,0,1,1,0,10.844Zm0-8.746a3.337,3.337,0,0,0,0,6.673,3.338,3.338,0,0,0,0-6.673Z",
    transform: "translate(604.793 176.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M14.95,41.359a5.459,5.459,0,0,1,5.662-5.409,6.556,6.556,0,0,1,3.185.733c.152.1.177.2.1.329L23.191,38.5a.213.213,0,0,1-.3.1A4.934,4.934,0,0,0,20.562,38a3.4,3.4,0,0,0,.025,6.8,4.959,4.959,0,0,0,2.4-.607c.152-.051.228-.051.278.076l.708,1.517c.051.152.025.227-.1.3a6.7,6.7,0,0,1-3.286.758c-3.412,0-5.612-2.1-5.612-5.435Z",
    transform: "translate(612.386 176.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M22.2,42.218l-.859.859v3.236s-.1.228-.228.228H19.373a.233.233,0,0,1-.253-.228V36.227s.1-.227.253-.227h1.744a.212.212,0,0,1,.228.227v4.019l3.64-4.019a.662.662,0,0,1,.48-.227h2.25c.2,0,.278.177.1.354l-4.044,4.221,4.171,5.561c.152.177.152.4-.126.4H25.743a.485.485,0,0,1-.455-.228Z",
    transform: "translate(618.757 176.146)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbLogoOutline);
export default __webpack_public_path__ + "static/media/rb-logo-outline.89b990253507fa39c4ddcdb2365736ea.svg";
export { ForwardRef as ReactComponent };